import o from "styled-components";
import { Text as n } from "./atoms-v243.js";
import { Icon as i } from "./atoms-v217.js";
const d = o.div`
  background-color: ${({ $color: e, theme: t }) => t.get(e)};
  border-radius: ${({ theme: e }) => e.get("tokens.radius.cardRadiusSm")}px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  justify-content: space-between;
  padding: 16px 24px;
  width: 100%;
`, l = o.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`, a = o.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 48px;
  justify-content: flex-start;
`, p = o(n)`
  color: ${({ $textColor: e, theme: t }) => t.get(e)};
  ${({ theme: e }) => e.get("tokens.heading.02").toJS()}
`, x = o.div`
  padding-top: 7px;
`, g = o(i)`
  color: ${({ $color: e, theme: t }) => t.get(e)};
`, f = o.div`
  display: flex;
  flex-direction: column;
`, m = o(n)`
  color: ${({ $textColor: e, theme: t }) => t.get(e)};
  ${({ theme: e }) => e.get("tokens.helper.expressive").toJS()}
`, u = o(n)`
  color: ${({ $textColor: e, theme: t }) => t.get(e)};
  ${({ theme: e }) => e.get("tokens.body.expressive").toJS()}
`;
export {
  a as BottomSection,
  g as ColoredIcon,
  d as Container,
  x as IconContainer,
  m as Label,
  p as NameOnTheCard,
  f as TextContainer,
  l as TopSection,
  u as Value
};
